"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _default = exports.default = (0, _core.makeStyles)(theme => ({
  root: {
    padding: theme.spacing(2)
  },
  stepper: {
    padding: theme.spacing(0, 7, 0, 7),
    backgroundColor: 'transparent',
    marginTop: -20,
    marginBottom: 25
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  button: {
    marginLeft: theme.spacing(1)
  },
  main: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  mainLeft: {
    width: '40%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    },
    [theme.breakpoints.down('xs')]: {
      alignItems: 'flex-start'
    }
  },
  img: {
    width: '110%'
  },
  textPrimary: {
    fontWeight: 600,
    fontSize: 18,
    marginTop: 0,
    marginBottom: 0
  },
  textTertiary: {
    fontSize: 18,
    marginTop: 0,
    marginBottom: 0
  },
  textSecondary: {
    fontSize: 18,
    marginLeft: 10,
    marginTop: 0,
    marginBottom: 20
  },
  title: {
    fontWeight: 600,
    fontSize: 18,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 125,
    marginRight: 125,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginRight: 0
    }
  },
  feature: {
    display: 'flex',
    alignItems: 'center',
    lineHeight: 1,
    marginBottom: 10
  },
  subheader: {
    fontSize: 18,
    lineHeight: 1.2
  },
  header: {
    fontWeight: 'bold',
    marginBottom: 10
  },
  image: {
    width: '100%',
    height: '85%'
  },
  mainRight: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  }
}));